import React, { Component, PropTypes } from 'react';
import Video from './Video';

class LiveStreamVideoSwitcher extends Component {
  static propTypes = {
    titles: PropTypes.array,
    streamUrls: PropTypes.array,
    posterUrls: PropTypes.array,
    adTag: PropTypes.string,
    autoPlay: PropTypes.bool
  };

  static defaultProps = {
    titles: [],
    streamUrls: [],
    posterUrls: [],
    adTag: "",
    autoPlay: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      video: ''
    };

    this.updateVideo = this.updateVideo.bind(this);

  }
  shouldComponentUpdate() {
  	return false;
  }
  componentWillMount() { // set initial video
    const wNVideoCanvasProps = [{
      SetFlashLiveStream: [{
        strUrl: this.props.streamUrls[0],
        strHeadline: this.props.titles[0],
        strAdTag: this.props.adTag,
        hasPreroll: (this.props.adTag !== "" ? true : false),
        strSummaryImageUrl: this.props.posterUrls[0],
        mobileStreams: [{
          url: '',
          type: 'video/mp4'
        }, {
          url: '',
          type: 'video/mp4'
        }, {
          url: '',
          type: 'video/mp4'
        }]
      }]
    }];

    this.setState({
      video: <Video clipId={1} autoPlay={this.props.autoPlay} wNVideoCanvasProps={wNVideoCanvasProps} />
    });
  }

  async updateVideo(id) {
    if (FranklyVideoPlayerList && FranklyVideoPlayerList[0] && FranklyVideoPlayerList[0].playerInfo && FranklyVideoPlayerList[0].playerInfo.playerId) {
      autoplayPossible = true; // hack fix for Chrome to play on second video. can be removed after forceAutoplay is added in legacy PR #487
      var franklyStreamPlayer = FranklyVideoPlayerList[0].playerInfo;
      franklyStreamPlayer.vars.liveStreamUrl = this.props.streamUrls[id]; // these 3 get read & propated into various places during loadInitialVideo
      franklyStreamPlayer.vars.liveStreamHeadline = this.props.titles[id];
      franklyStreamPlayer.vars.liveStreamSummaryImgUrl = this.props.posterUrls[id];
      franklyStreamPlayer.enableLeaveBehind = false;
      franklyStreamPlayer.canFireResumeAfterPause = false;

      franklyStreamPlayer.loadInitialVideo(true);  // true == force autoplay
      evntMgr.Notify({
          evnt: 'NewClip',
          idKey: franklyStreamPlayer.vars.idKey,
          objClip: franklyStreamPlayer.currentClip
      });
    }
  }

  render(){

    this.vidContainerStyles = {
      gridTemplateAreas: ""
    };

    var vidList = this.props.streamUrls.map(function(streamUrl, index){

      this.vidContainerStyles.gridTemplateAreas += "'main vid" + index + "' ";

      if (this.props.streamUrls.length > 3 && index > 2) { // add extra 4th row
        this.vidContainerStyles.gridTemplateRows += "1fr ";
      }

      var vidThumbStyles = {
        backgroundImage: 'linear-gradient(0deg,rgba(0,0,0,.5),transparent), url("'+ this.props.posterUrls[index] +'")',
        gridArea: 'vid' + index
      }
      return (
          <div style={vidThumbStyles} className="vidSwitcherThumb" onClick={() => this.updateVideo(index)} >
            <img src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDYwIDYwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA2MCA2MDsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI2NHB4IiBoZWlnaHQ9IjY0cHgiPgo8cGF0aCBkPSJNMzAsMEMxMy40NTgsMCwwLDEzLjQ1OCwwLDMwczEzLjQ1OCwzMCwzMCwzMHMzMC0xMy40NTgsMzAtMzBTNDYuNTQyLDAsMzAsMHogTTQ1LjU2MywzMC44MjZsLTIyLDE1ICBDMjMuMzk0LDQ1Ljk0MSwyMy4xOTcsNDYsMjMsNDZjLTAuMTYsMC0wLjMyMS0wLjAzOC0wLjQ2Ny0wLjExNkMyMi4yMDUsNDUuNzExLDIyLDQ1LjM3MSwyMiw0NVYxNWMwLTAuMzcxLDAuMjA1LTAuNzExLDAuNTMzLTAuODg0ICBjMC4zMjgtMC4xNzQsMC43MjQtMC4xNSwxLjAzMSwwLjA1OGwyMiwxNUM0NS44MzYsMjkuMzYsNDYsMjkuNjY5LDQ2LDMwUzQ1LjgzNiwzMC42NCw0NS41NjMsMzAuODI2eiIgZmlsbD0iI0ZGRkZGRiIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K" />
            <br/>{this.props.titles[index]}
          </div>
      );
    }.bind(this));

    for (var i = 1; i <= 3; i++) { // add empty cells if less than 3 streams
      if (this.props.streamUrls.length < i) {
        this.vidContainerStyles.gridTemplateAreas += "'main .'";
      }
    }

    return (
      <div className='vidSwitcher'>
      	<div className="vidSwitcherContainer" style={this.vidContainerStyles}>
      	  <div className="vidSwitcherMain" style={{gridArea: 'main'}}><span className='VideoModuleDemo-Video'>{this.state.video}</span></div>
          {vidList}
      	</div>
      </div>
    );

  }

}
export default LiveStreamVideoSwitcher;



// WEBPACK FOOTER //
// ./app/components/media/LiveStreamVideoSwitcher.js